// Generated by CoffeeScript 1.12.7
(function () {
  var KeenDataViz,
    ProjectsVisualization,
    bind = function (fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

  KeenDataViz = require("keen-dataviz")["default"];

  module.exports = ProjectsVisualization = (function () {
    ProjectsVisualization.prototype.chart = null;

    function ProjectsVisualization(createUi, $q, entityData, onLoad) {
      this.renderChart = bind(this.renderChart, this);
      this.ui = createUi(require("Analytics/Visualizations/Projects/Projects.html"), {
        projects: {},
        loaded: false,
        $onElementRendered: (function (_this) {
          return function (elem) {
            return $q
              .all([entityData.getProjectCounts(), entityData.getProjectCountsByDate()])
              .then(function (results) {
                _this.ui.loaded = true;
                if (results.length > 1) {
                  _this.ui.projects = results[0].data;
                  if (onLoad) {
                    onLoad();
                  }
                  return _this.renderChart(results[1].data, elem);
                }
              });
          };
        })(this),
      });
    }

    ProjectsVisualization.prototype.renderChart = function (data, elem) {
      var container;
      container = $(elem).find(".chart--projects")[0];
      return (this.chart = new KeenDataViz({
        container: container,
        type: "bar",
        grid: {
          x: {
            show: true,
          },
        },
      })
        .data(data)
        .render());
    };

    return ProjectsVisualization;
  })();
}.call(this));
